import { render, staticRenderFns } from "./ChatBoxPlugin.vue?vue&type=template&id=50c40191"
import script from "./ChatBoxPlugin.vue?vue&type=script&lang=js"
export * from "./ChatBoxPlugin.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxPlugin.vue?vue&type=style&index=0&id=50c40191&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports